export default {
    defaultChipStatus: {
        backgroundColor: "#ededed",
        color: "#4a4d50",
        borderColor: "#4a4d50",

        border: "1px solid",
        textTransform: "capitalize"
    },
    greyChip: {
        backgroundColor: "#ededed",
        color: "#4a4d50",
        borderColor: "#4a4d50",
        height: "20px",
        border: "1px solid",
        textTransform: "capitalize"
    },
    blueChip: {
        backgroundColor: "#ebf2ff",
        color: "#007aff",
        height: "20px",
        borderColor: "#007aff",
        border: "1px solid",
        textTransform: "capitalize"
    },
    greenChip: {
        backgroundColor: "#e9f9f0",
        color: "#2bc064",
        height: "20px",
        borderColor: "#2bc064",
        border: "1px solid",
        textTransform: "capitalize"
    }
};
